import React, { useState, useEffect } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../assets/css/icones/iconsmind/style.css';
import { Link } from 'react-router-dom'
import { OverlayTrigger, Tooltip, Popover } from 'react-bootstrap';
import { useHover, UpdatingTooltip, mensagens } from './../util/Utilitarios';
import { excluir, get, putComAcao } from './../util/AcessoApi'

import { ACOES, MODULO } from '../util/Enums';
import { mostrarToast } from './Toasts';
import { getUsuario } from '../util/Configuracoes';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function renderTooltip(props, nome, classTooltip) {
    delete props.show;
    return <Tooltip id={'tooltip ' + props.id ? props.id : 'tooltip ' + Math.random()} className={classTooltip} {...props}>{nome}</Tooltip>;
}

const BtnAcaoLink = (props) => {
    const { texto, icone, to } = props
    const classTooltip = props.classTooltip

    return (
        <div className="icone ptb-10">
            <OverlayTrigger
                popperConfig={{
                    modifiers: {
                        preventOverflow: {
                            enabled: false
                        }
                    }
                }}
                placement="bottom"
                delay={{ show: 25, hide: 25 }}
                overlay={(props) => renderTooltip(props, texto, classTooltip)}>
                <Link to={to} className={"icon-consulta btn-acao " + icone} target={props.target || 'blank'} />
            </OverlayTrigger>
        </div>
    )
}

const BtnAcaoLinkPermissao = (props) => {
    const history = useHistory();
    const { to } = props

    const objPermissao = {
        usuario_id: getUsuario().id,
        modulo_id: props.modulo,
        acao_id: props.acao
    }
    const validarPermissao = () => {
        Promise.resolve(get('/controleAcesso/permissao', objPermissao)).then(function (val) {
            if (val?.length)
                window.open(to, props.target || '_blank');
            else {
                mostrarToast('erro', mensagens['permissao'])
            }
        }).catch((e) => {
            mostrarToast('erro', mensagens['erro'])
        })
    }

    return (
        <BtnAcao {...props} action={validarPermissao} />
    )
}

const BtnAcao = (props) => {
    const { texto, icone, type } = props
    const classTooltip = props.classTooltip
    let nomeBotao = props.disabled?.disabledRow && props.disabled?.id === props.id ? 'Aguarde' : texto
    const buttonStyle = {
        opacity: props.disabled?.disabledRow && props.disabled?.id === props.id ? 0.4 : 1,
        cursor: props.disabled?.disabledRow && props.disabled?.id === props.id ? 'default' : 'pointer',
    };
    return (
        <div className={`icone ` + props.className} style={props.ajusta_padding && { padding: 20 }}>
            {
                texto && <OverlayTrigger
                    popperConfig={{
                        modifiers: {
                            preventOverflow: {
                                enabled: false
                            }
                        }
                    }}
                    id={props.id ? props.id : Math.random()}
                    placement="bottom"
                    delay={{ show: 25, hide: 25 }}
                    overlay={(props) => renderTooltip(props, nomeBotao, classTooltip)}>

                    {props.loading ? <span className="spinner-border spinner-border-md" style={{ height: 20, width: 20, opacity: 0.2 }} role="status" aria-hidden="true"></span> :
                        <button type={type && type || 'submit'} style={buttonStyle} disabled={props.disabled?.disabledRow && props.disabled?.id === props.id || false} className={"btn-acao-alternativo " + icone + " " + (props.cortarIcone ? "strikediag" : "")} onClick={() => props.action()} />}

                </OverlayTrigger>
                || <button type={type && type || 'submit'} disabled={props.disabled?.disabledRow && props.disabled?.id === props.id || false} style={buttonStyle} className={"btn-acao-alternativo " + icone + " " + (props.cortarIcone ? "strikediag" : "")} onClick={() => props.action()} />
            }
        </div>)
}

const Btn = (props) => {
    const { texto, icone } = props
    const classTooltip = props.classTooltip

    return (
        <div className="icone">
            {
                texto && <OverlayTrigger
                    popperConfig={{
                        modifiers: {
                            preventOverflow: {
                                enabled: false
                            }
                        }
                    }}
                    placement="bottom"
                    delay={{ show: 25, hide: 25 }}
                    overlay={(props) => renderTooltip(props, texto, classTooltip)}>
                    <button className={"btn-acao " + icone + " " + (props.cortarIcone ? "strikediag" : "")} />
                </OverlayTrigger>
                || <button className={"btn-acao " + icone + " " + (props.cortarIcone ? "strikediag" : "")} />
            }
        </div>)
}

const BtnAcaoConfirmar = (props) => {
    const [contador, setContador] = useState(0)
    const { texto, icone, type, mensagemConfirmacao } = props
    const [hoverRef, isHovered] = useHover();

    useEffect(() => {
        if (!isHovered) {
            setContador(0)
        }
    }, [isHovered])

    return (<div className="icone">

        <OverlayTrigger
            popperConfig={{
                modifiers: {
                    preventOverflow: {
                        enabled: false
                    }
                }
            }}
            placement={"bottom"}
            delay={{ show: 25, hide: 25 }}
            overlay={
                <UpdatingTooltip className={props.classTooltip + (contador === 1 ? " bottom-tooltip" : "")} id="popover-contained">{(contador === 1 ? mensagemConfirmacao || "Tem certeza que deseja excluir?" : texto)}</UpdatingTooltip>
            }
        >

            <button ref={hoverRef} className={"btn-acao " + (contador == 1 ? " icon-Yes" : icone)} type={type && type || 'submit'} onClick={() => {
                if ((contador + 1) == 2) {
                    props.action();
                    setContador(0);
                }
                setContador(contador + 1);
            }
            } /></OverlayTrigger>

    </div>)
}

const LinkExclusaoTabelaPequena = (props) => {
    const [contador, setContador] = useState(0)
    const { texto, icone } = props
    const [hoverRef, isHovered] = useHover();

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!loading) {
            setContador(0)
        }
    }, [loading])

    useEffect(() => {
        if (!isHovered) {
            setContador(0)
        }
    }, [isHovered])


    return (<div style={{ display: 'inline' }}>
        <a ref={hoverRef} onClick={() => {
            props.action && props.action();
            if ((contador + 1) == 2) {
                setLoading(true);
                excluir(props.url, props.idItem, () => { props.acaoAposExclusao(); setLoading(false); }, () => { props.acaoAposErro && props.acaoAposErro(); setLoading(false); }, props.descricao)
                setContador(0);
            }
            setContador(contador + 1);
        }} style={{ paddingLeft: '10px' }} class='link'><span className={(contador == 1 ? " icon-Yes" : icone)}></span> {loading ? 'aguarde...' : (contador == 0 ? 'excluir' : 'confirme')}</a>
    </div>)
}

const LinkAlteracaoTabelaPequena = (props) => {
    const { texto, icone } = props
    const [loading, setLoading] = useState(false)


    return (<div style={{ display: 'inline' }}>
        <OverlayTrigger
            popperConfig={{
                modifiers: {
                    preventOverflow: {
                        enabled: false
                    }
                }
            }}
            placement="bottom"
            delay={{ show: 25, hide: 25 }}
            overlay={
                <UpdatingTooltip className={props.classTooltip} id="popover-contained">{texto}</UpdatingTooltip>
            }
        >
            <a href="#" onClick={() => {
                props.action();
            }} style={{ paddingLeft: '10px' }} class='link'><span className={icone}></span> {loading ? 'aguarde...' : (props.textoInline && props.textoInline || 'alterar')}</a>
        </OverlayTrigger></div>)
}
const LinkAlteracaoTabelaPequenaPersonalizado = (props) => {
    const { texto, icone } = props
    const [loading, setLoading] = useState(false)


    return (<div style={{ display: 'inline' }}>
        <OverlayTrigger
            popperConfig={{
                modifiers: {
                    preventOverflow: {
                        enabled: false
                    }
                }
            }}
            placement="bottom"
            delay={{ show: 25, hide: 25 }}
            overlay={
                <UpdatingTooltip className={props.classTooltip} id="popover-contained">{texto}</UpdatingTooltip>
            }
        >
            <a onClick={() => {
                props.action();
            }} style={{ paddingLeft: '10px' }} class='link'><span className={icone}></span> {loading ? 'aguarde...' : (props.textoInline && props.textoInline || 'alterar')}</a>
        </OverlayTrigger></div>)
}
const LinkExclusaoTabelaPequenaPersonalizado = (props) => { // aq

    const [contador, setContador] = useState(0)
    const { texto, icone } = props
    const [hoverRef, isHovered] = useHover();

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!loading) {
            setContador(0)
        }
    }, [loading])

    useEffect(() => {
        if (!isHovered) {
            setContador(0)
        }
    }, [isHovered])

    return (<div style={{ display: 'inline' }}>
        <a ref={hoverRef} onClick={() => {

            if ((contador + 1) == 2) {

                setLoading(true);
                // excluir(props.url, props.idItem, () => { props.acaoAposExclusao(); setLoading(false); }, (e) => { props.acaoAposErro && props.acaoAposErro(e); setLoading(false); }, props.descricao)
                if (!props.idItem) {
                    props.action && props.action();
                    setLoading(false)

                } else {
                    putComAcao(
                        ACOES.REMOVER_LIQUIDACAO,
                        MODULO["/financeiro/lancamentofinanceiro"],
                        { id: props.idItem, apenasMovimento: true },
                        '/financeiro/removerliquidacao',
                        () => {
                            props.acaoAposExclusao(); setLoading(false);
                        },
                        (e) => { props.acaoAposErro && props.acaoAposErro(e); setLoading(false); })
                }

                setContador(0);
            }
            setContador(contador + 1);
        }} style={{ paddingLeft: '10px' }} class='link'><span className={(contador == 1 ? " icon-Yes" : icone)}></span> {loading ? 'aguarde...' : (contador == 0 ? 'excluir' : 'confirme')}</a>
    </div>)
}

const LinkVisualizacaoTabelaPequena = (props) => {
    const { texto, icone } = props
    const [loading, setLoading] = useState(false)


    return (<div style={{ display: 'inline' }}>
        <OverlayTrigger
            popperConfig={{
                modifiers: {
                    preventOverflow: {
                        enabled: false
                    }
                }
            }}
            placement="bottom"
            delay={{ show: 25, hide: 25 }}
            overlay={
                <UpdatingTooltip className={props.classTooltip} id="popover-contained">{texto}</UpdatingTooltip>
            }
        >
            <a onClick={() => {

                if (props.action)
                    props.action();
            }} style={{ paddingLeft: '10px' }} class='link'><span className={icone}></span> {loading ? 'aguarde...' : (props.textoInline && props.textoInline || 'visualizar')}</a>
        </OverlayTrigger></div>)
}
const LinkVisualizacaoTabelaPequenaPersonalizado = (props) => {
    const { texto, icone } = props
    const [loading, setLoading] = useState(false)


    return (<div style={{ display: 'inline' }}>
        <OverlayTrigger
            popperConfig={{
                modifiers: {
                    preventOverflow: {
                        enabled: false
                    }
                }
            }}
            placement="bottom"
            delay={{ show: 25, hide: 25 }}
            overlay={
                <UpdatingTooltip className={props.classTooltip} id="popover-contained">{texto}</UpdatingTooltip>
            }
        >
            <a href="#" onClick={() => {

                if (props.action)
                    props.action();
            }} style={{ paddingLeft: '10px' }} class='link'><span className={icone}></span> {loading ? 'aguarde...' : (props.textoInline && props.textoInline || 'visualizar')}</a>
        </OverlayTrigger></div>)
}
const LinkVisualizacaoTabelaPequenaPersonalizadoLancamento = (props) => {
    const { texto, icone } = props
    const [loading, setLoading] = useState(false)


    return (<div style={{ display: 'inline' }}>
        <OverlayTrigger
            popperConfig={{
                modifiers: {
                    preventOverflow: {
                        enabled: false
                    }
                }
            }}
            placement="bottom"
            delay={{ show: 25, hide: 25 }}
            overlay={
                <UpdatingTooltip className={props.classTooltip} id="popover-contained">{texto}</UpdatingTooltip>
            }
        >
            <a onClick={() => {

                if (props.action)
                    props.action();
            }} style={{ paddingLeft: '10px' }} class='link'><span className={icone}></span> {loading ? 'aguarde...' : (props.textoInline && props.textoInline || 'visualizar')}</a>
        </OverlayTrigger></div>)
}

const BtnAcaoAlternativa = (props) => {

    const { texto, icone, to } = props
    const classTooltip = props.classTooltip

    return (
        <div className="icone">
            <OverlayTrigger
                popperConfig={{
                    modifiers: {
                        preventOverflow: {
                            enabled: false
                        }
                    }
                }}
                placement="bottom"
                delay={{ show: 25, hide: 25 }}
                overlay={(props) => renderTooltip(props, texto, classTooltip)}>
                <Link to={to} className={"icon-consulta btn-acao " + icone} onClick={() => props.action()} />
            </OverlayTrigger>
        </div>
    )
}
const PopoverPadrao = (props) => {
    return (
        <OverlayTrigger
            trigger={["hover", "focus"]}
            placement={"bottom"}
            onToggle={() => props.onToggle && props.onToggle()}
            target={`popover-positioned-${props.id}`}
            overlay={
                <Popover id={`popover-positioned-${props.id}`}>
                    <Popover.Title as="h3">{props.titulo}</Popover.Title>
                    <Popover.Content>
                        {props.conteudo}
                    </Popover.Content>
                    {props.info}
                </Popover>
            }
        >
            {props.children}
        </OverlayTrigger>
    )
}

const PopoverConsultaLancamento = (props) => {
    return (
        <OverlayTrigger
            trigger={["hover", "focus"]}
            placement={"bottom"}
            onToggle={() => props.onToggle && props.onToggle()}
            target={`popover-positioned-${props.id}`}
            overlay={
                <Popover id={`popover-positioned-${props.id}`}>
                    <Popover.Title as="h3">{props.titulo}</Popover.Title>
                    <Popover.Content>
                        {props.conteudo}
                    </Popover.Content>
                    {props.info}
                </Popover>
            }
        >
            {props.children}
        </OverlayTrigger>
    )
}

const PopoverConsultaLote = (props) => {
    return (
        <OverlayTrigger
            trigger={["hover", "focus"]}
            placement={"bottom"}
            onToggle={() => props.onToggle && props.onToggle()}
            target={`popover-positioned-${props.id}`}
            overlay={
                <Popover id={`popover-positioned-${props.id}`}>
                    <Popover.Title as="h3">{props.titulo}</Popover.Title>
                    <Popover.Content>
                        {props.conteudo}
                    </Popover.Content>
                    {props.info}
                </Popover>
            }
        >
            {props.children}
        </OverlayTrigger>
    )
}

const BtnAcaoReverterExclusao = (props) => {
    const [contador, setContador] = useState(0)
    const { texto, icone, type } = props
    const [hoverRef, isHovered] = useHover();

    useEffect(() => {
        if (!isHovered) {
            setContador(0)
        }
    }, [isHovered])

    return (<div className="icone">

        <OverlayTrigger
            popperConfig={{
                modifiers: {
                    preventOverflow: {
                        enabled: false
                    }
                }
            }}
            placement={"bottom"}
            delay={{ show: 25, hide: 25 }}
            overlay={
                <UpdatingTooltip className={props.classTooltip + (contador === 1 ? " bottom-tooltip" : "")} id="popover-contained">{(contador === 1 ? "Tem certeza que deseja reverter?" : texto)}</UpdatingTooltip>
            }
        >

            <button ref={hoverRef} className={"btn-acao " + (contador == 1 ? " icon-Yes" : icone)} type={type && type || 'submit'} onClick={() => {
                if ((contador + 1) == 2) {
                    props.action();
                    setContador(0);
                }
                setContador(contador + 1);
            }
            } /></OverlayTrigger>

    </div>)
}

const UpdatingPopover = React.forwardRef(
    ({ popper, children, show: _, ...props }, ref) => {
        useEffect(() => {
            popper.scheduleUpdate();
        }, [props.copiado, popper]);

        return (
            <Popover ref={ref} body {...props}>
                {children}
            </Popover>
        );
    },
);

const BtnAcaoConfirmarModal = (props) => {
    const [contador, setContador] = useState(0)
    const { texto, icone, type, mensagemConfirmacao } = props
    const [hoverRef, isHovered] = useHover();

    useEffect(() => {
        if (!isHovered) {
            setContador(0)
        }
    }, [isHovered])

    return (<div className="icone">

        <OverlayTrigger
            popperConfig={{
                modifiers: {
                    preventOverflow: {
                        enabled: false
                    }
                }
            }}
            placement={"bottom"}
            delay={{ show: 25, hide: 999999999999 }}
            overlay={
                <UpdatingTooltip className={props.classTooltip + 'tooltip-input-modaltestr' + (contador === 1 ? " bottom-tooltip" : "")} id="popover-contained-teste">{(contador === 1 ? mensagemConfirmacao || "Tem certeza que deseja excluir?" : texto)}</UpdatingTooltip>
            }
        >

            <button ref={hoverRef} className={"btn-acao-alternativo testetesteste " + (contador == 1 ? " icon-Yes" : icone)} type={type && type || 'submit'} onClick={() => {
                if ((contador + 1) == 2) {
                    props.action();
                    setContador(0);
                }
                setContador(contador + 1);
            }
            } /></OverlayTrigger>

    </div>)
}


const BtnGroup = (props) => <div className="btn-group"> {props.children} </div>
const Alterar = (props) => <BtnAcaoLink icone="icon-Pen" texto="Alterar" to={props.to} target={props.target || 'blank'} />
const AlterarComPermissao = (props) => <BtnAcaoLinkPermissao icone="icon-Pen" texto="Alterar" to={props.to} id={props.id} target={props.target || 'blank'} {...props} />
const Excluir = (props) => <BtnAcaoConfirmar icone="icon-New-Trash" texto="Excluir" action={props.action} {...props} />
const Visualizar = (props) => <BtnAcaoLink icone="icon-File-Search" texto="Visualizar" to={props.to} {...props} />
const Imprimir = (props) => <BtnAcao icone="icon-Printer" texto="Imprimir" action={props.action} loading={props.loading} {...props} />
const Download = (props) => <BtnAcao icone="icon-Download" texto="Download PDF" to={props.to} {...props} />
const Voltar = (props) => <BtnAcao icone="icon-Arrow-Left" texto="Voltar" to={props.to} {...props} />
const Validar = (props) => <BtnAcao icone="icon-Checked-User" texto={props.texto || "Validar"} action={props.action} {...props} />
const BloqueioAgendamento = (props) => <BtnAcao icone="icon-Calendar-3 strikediag" texto="Bloqueio de Agendamento" action={props.action} {...props} />



const Reenvio = (props) => <BtnAcao icone="icon-Mail-Send" texto="Reenviar" action={props.action} {...props} />
const AlteracaoLote = (props) => <BtnAcao icone="icon-Big-Data" texto="Inserir/Alterar Lote" action={props.action} {...props} />
const AlteracaoStatus = (props) => <BtnAcao icone="icon-Check" texto="Alterar Status" action={props.action} {...props} />
const HistoricoStatus = (props) => <BtnAcao icone="icon-Books-2" texto="Visualização Detalhes (Lote/Status) " action={props.action} {...props} />
const EnviarNotificacao = (props) => <BtnAcao icone="icon-Mail-Send" texto="Enviar Notificação" action={props.action} {...props} />
const AlterarPersonalizado = (props) => <BtnAcaoAlternativa texto="Alterar" action={props.action} {...props} to={props.to} />
const ReverterExclusao = (props) => <BtnAcaoReverterExclusao icone="icon-Repeat-3" texto="Reverter Exclusão" action={props.action} {...props} />
const LinkBotao = (props) => <BtnAcaoLink icone={props.icone} texto={props.texto} to={props.to} />
const MarcarFolga = (props) => <BtnAcao icone={props.icone} texto={props.texto} to={props.to} action={props.action}  {...props} />
const LinkArquivos = (props) => <BtnAcao icone="icon-Upload-toCloud" texto="Inserir/Alterar Arquivos" action={props.action} {...props} />

//botoes lote guia
const Detalhes = (props) => <BtnAcao icone="icon-Books-2" texto="Detalhes" action={props.action} {...props} />

const MinimizarDados = (props) => <BtnAcao icone={"icon-Eye-Visible " + props.className} texto={props.texto} action={props.action} {...props} />

//ACOES PRONTUARIO
const VisualizarProntuario = (props) => <BtnAcao icone={"icon-File-Search"} texto='Visualizar' to={props.to} action={props.action} {...props} />


export {
    BtnGroup, BtnAcao, Alterar, Excluir, Visualizar, Imprimir, Download, BtnAcaoLink, Voltar, Validar, Reenvio, Btn, PopoverPadrao, EnviarNotificacao, AlterarPersonalizado, LinkBotao,
    ReverterExclusao, AlteracaoLote, AlteracaoStatus, HistoricoStatus, Detalhes, MinimizarDados, PopoverConsultaLancamento, LinkExclusaoTabelaPequenaPersonalizado, BtnAcaoAlternativa,
    MarcarFolga, BtnAcaoConfirmar, LinkArquivos, AlterarComPermissao, PopoverConsultaLote,
    BtnAcaoConfirmarModal, BloqueioAgendamento, VisualizarProntuario
}

